import { useQuery } from "@apollo/client/react"
import { useVenue } from "@/contexts/venue"
import {
  GetReservationsDocument,
  GetReservationsQuery,
  GetPublicReservationDocument,
  ReservationDateFilterInput,
  ReservationStatus,
} from "@/graphql/graphql"

type UseReservationsInput = {
  dateFilter?: ReservationDateFilterInput
  status?: ReservationStatus[]
  includeRemoved?: boolean
  tableGroups?: string | string[]
}

export const useReservations = ({ dateFilter, status, includeRemoved = false, tableGroups }: UseReservationsInput) => {
  const { venue } = useVenue()
  const { data, loading, error } = useQuery(GetReservationsDocument, {
    variables: {
      slug: venue.slug,
      dateFilter,
      status,
      includeRemoved,
      tableGroups,
    },
  })

  const reservations: GetReservationsQuery["venue"]["reservations"]["nodes"] = data?.venue.reservations.nodes || []
  return { reservations, loading, error }
}

type UsePublicReservationInput = {
  uuid: string
}

export const usePublicReservation = ({ uuid }: UsePublicReservationInput) => {
  const { data, loading, error, refetch } = useQuery(GetPublicReservationDocument, {
    variables: { uuid },
  })

  const reservation = data?.public?.reservation
  return { reservation, loading, error, refetch }
}
